import { BitrixVue, reactive } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { VplRouter } from 'vpl.tas';
import { setCookie, getCookie } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { CatalogCard } from 'vpl.tas';
import { CheckboxItem } from 'vpl.tas';
import { showCatalogPreloader, hideCatalogPreloader  } from 'vpl.tas';
import { holdCatalogPreloader, releaseCatalogPreloader } from 'vpl.tas';



export const CatalogItems = {
    components: {
        ItemEditBtns,
        CatalogCard,
        CheckboxItem
    },
    props: {
        structKey: [String, Number]
    },
    updated(){
        this.items = this.sectionData.ITEMS;
        this.pagin = this.sectionData.PAGIN;
    },
    mounted(){
        this.items = this.sectionData.ITEMS;
        this.pagin = this.sectionData.PAGIN;

        $(this.$el).find('.js-select').niceSelect();

        $(this.$el).find('select.js-sort-select').change(() => this.changeSort());

        $(".js-list-close").on("click", function () {
            $('.js-nice-select-catalog').removeClass('open');
        });

        if (this.sectionData.CUSTOM_TITLE)
            $('h1').text(this.sectionData.CUSTOM_TITLE);

    },
    methods: {
        getCookie: getCookie,
        lazyLoad(link ,append = true){

            link = link.split('#')[0];
            let arRoute = link.split('?');
            let params = 'get_json=Y';
            if(arRoute[1]){
                params += '&' + arRoute[1];
            }

            holdCatalogPreloader();
            $.ajax({
                url: arRoute[0] + '?' + params,
                method: 'GET',
                complete: () => releaseCatalogPreloader(),
                success: (response) => {
                    response = JSON.parse(response);
                    if(append){
                        this.sectionData.ITEMS = [...this.items, ...response.struct[this.structKey].CHILDS[this.childKey].componentData.ITEMS];
                    }else{
                        this.sectionData.ITEMS = response.struct[this.structKey].CHILDS[this.childKey].componentData.ITEMS;

                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(this.$el).offset().top - 70
                        }, 500);
                    }
                    this.sectionData.PAGIN = response.struct[this.structKey].CHILDS[this.childKey].componentData.PAGIN;

                     
                    if (
                        !append
                        && window.history
                        && window.history.pushState
                    ) {
                        const historyUrl =
                            arRoute[0]
                            + (
                                arRoute[1]
                                    ? '?' + arRoute[1]
                                    : ''
                            );

                        window.history.pushState(
                            historyUrl,
                            document.title,
                            historyUrl
                        );
                    }

                }
            });
        },
        setCardView(e) {

            setCookie("catalogView", "card", 30);

            $('.js-view-line').removeClass('is-active');
            $('.js-view-card').addClass('is-active');
            $('.js-catalog-list').removeClass('line-view');

        },
        setLineView(e) {

            setCookie("catalogView", "wide", 30);

            $('.js-view-card').removeClass('is-active');
            $('.js-view-line').addClass('is-active');
            $('.js-catalog-list').addClass('line-view');

        },
        changeSort(){

            let data = $(this.$el).find('select.js-sort-select').val().split("/");
            setCookie("sort", data[0], 30);
            setCookie("sort_dir", data[1], 30);

            let arRoute = window.location.href.split('?');
            let params = 'get_json=Y';
            if(arRoute[1]){
                params += '&' + arRoute[1];
            }

            $.ajax({
                url: arRoute[0] + '?' + params,
                method: "POST",
                data: { sort: data[0], sort_dir: data[1] },
                success:  (response) => {
                    response = JSON.parse(response);
                    this.sectionData.ITEMS = response.struct[this.structKey].CHILDS[this.childKey].componentData.ITEMS;
                    this.sectionData.PAGIN = response.struct[this.structKey].CHILDS[this.childKey].componentData.PAGIN;
                },
            });

        },
        mobileFilter(e){
            let link = $(e.target)
            if ($(window).width() < 992) {
                if (!link.hasClass('is-active')) {
                    link.addClass('is-active');
                    $('.js-filter-mob').addClass('is-open');
                    $('body').addClass('modal-open');
                    $('body').addClass('filter-open');
                    $('.js-panel').removeClass('is-active');
                } else {
                    link.removeClass('is-active');
                    $('.js-filter-mob').removeClass('is-open');
                    $('body').removeClass('modal-open');
                    $('body').removeClass('filter-open');
                    $('.js-panel').addClass('is-active');
                }
            }
        },
        catalogOverkayClick(e){
            $('body').removeClass('modal-open');
            $('.js-nice-select-catalog').removeClass('open');
            $(e.target).removeClass('is-show');
        }

    },
    computed: {
        ...mapState(vplSiteStore, ['templateData', 'struct', 'title']),
        childKey(){
            for(let i in this.struct[this.structKey].CHILDS){
                if(this.struct[this.structKey].CHILDS[i].componentData.VUE_COMPONENT == 'CatalogItems'){
                    return i;
                }
            }
        },
        sectionData(){
            return this.struct[this.structKey].CHILDS[this.childKey].componentData;
        }
    },
    template: `

        <div class="catalog__rightside">
            <div class="catalog__rightside-top">

                <a href="#" class="catalog__filter-mob js-filter-link" @click.prevent="this.mobileFilter($event)">
                    <svg class="icon icon-filter"><use xlink:href="#icon-filter"></use></svg>
                    <span v-if="this.templateData.filterCount && this.templateData.filterCount > 0">{{ this.templateData.filterCount }}</span>
                </a>
                <div class="sort__select-wp">
                    <select name="" id="" class="sort__select js-select js-nice-select-catalog js-sort-select" @change="changeSort($event)">
                        <option :selected="(!this.getCookie('sort') || this.getCookie('sort') == 'DEFAULT')" value="DEFAULT/DEFAULT">Сортировка по умолчанию</option>
                        <option :selected="(this.getCookie('sort') == 'PRICE' && this.getCookie('sort_dir') == 'ASC')" value="PRICE/ASC">Сначала дешевле</option>
                        <option :selected="(this.getCookie('sort') == 'PRICE' && this.getCookie('sort_dir') == 'DESC')" value="PRICE/DESC">Сначала дороже</option>
                        <option :selected="(this.getCookie('sort') == 'created_date')" value="created_date/DESC">По новизне</option>
                        <option :selected="(this.getCookie('sort') == 'shows')" value="shows/DESC">По популярности</option>
                    </select>
                    <div class="catalog__overlay js-catalog-overlay" @click="catalogOverkayClick($event)"></div>
                </div>
                <div class="catalog__items-view">
                    <a href="#" @click.prevent="this.setCardView($event)" class="catalog__items-view-item js-view-card" :class="{'is-active': !this.getCookie('catalogView') || this.getCookie('catalogView') == 'card'}">
                        <svg class="icon icon-view-card"><use xlink:href="#icon-view-card"></use></svg>
                    </a>
                    <a href="#" @click.prevent="this.setLineView($event)" class="catalog__items-view-item js-view-line" :class="{'is-active': this.getCookie('catalogView') == 'wide'}">
                        <svg class="icon icon-view-line"><use xlink:href="#icon-view-line"></use></svg>
                    </a>
                </div>

            </div>
            <div class="catalog__items-list js-catalog-list" v-if="this.sectionData.ITEMS" :class="{'line-view': this.getCookie('catalogView') == 'wide'}">
                <template v-for="item in this.sectionData.ITEMS">
                    <CatalogCard :item="item"/>
                </template>

                <div class="content-nav" v-if="this.sectionData.PAGIN">
                    <ul class="content-nav__list">
                        <template v-for="link in this.sectionData.PAGIN">
                            <li v-if="link.type==='left_arrow'" class="content-nav__list-item content-nav__list-item--prev">
                                <a :href="link.link" @click.prevent="lazyLoad(link.link, false)" data-skip="y">
                                    <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                                </a>
                            </li>
                            <li v-if="link.type==='number'" :class="{active: link.selected}" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.selected ? '#' : link.link">{{ link.text }}</a></li>
                            <li v-if="link.type==='dots'" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.link">...</a></li>
                            <li v-if="link.type==='right_arrow'" class="content-nav__list-item content-nav__list-item--next">
                                <a :href="link.link" data-skip="y" @click.prevent="lazyLoad(link.link, false)">
                                    <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                                </a>
                            </li>
                        </template>
                    </ul>

                    <template v-for="link in this.sectionData.PAGIN">
                        <a v-if="link.type==='showmore'" href="#" @click.prevent="lazyLoad(link.link)" class="btn btn--border">Показать ещё</a>
                    </template>
                </div>

            </div>


        </div>

    `
}